module.exports = __webpack_public_path__ + "img/horizontal_7_3_pp3_8011.e2926c97.png";